<template>
    <v-snackbar
      v-model="snackBar"
      :color="snackBarcolor"
      :timeout="timeout"
      dark
    >
      {{ snackBarMessage }}
      <v-btn
        dark
        flat
        @click="snackBar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
</template>


<script>
  import { mapFields } from "vuex-map-fields";
  export default {
      name: 'SnackBar',
    data () {
      return {
        timeout: 4000,
      }
    },
    computed: {
    ...mapFields(["snackBarMessage",
        "snackBar","snackBarcolor"])
  }
  }
</script>